import { AWARDS } from "../../data/content";
import Reveal from "./Reveal";

export default function Awards() {
  return (
    <section
      id="awards"
      data-testid="awards-section"
      className="relative bg-[#050B14] py-24 md:py-40 border-t border-white/5"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
          <div className="col-span-12 lg:col-span-7">
            <Reveal>
              <div className="flex items-center gap-4 mb-8">
                <div className="h-px w-12 bg-[#E5D3B3]" />
                <span className="overline">{AWARDS.overline}</span>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <h2
                data-testid="awards-headline"
                className="font-serif-display text-white text-[clamp(2.25rem,5vw,4.5rem)] leading-[1.05] font-light tracking-[-0.02em] whitespace-pre-line"
              >
                {AWARDS.title}
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6 md:gap-10">
          {/* Primary award — large card */}
          <Reveal className="col-span-12 lg:col-span-7" delay={0.15}>
            <div
              data-testid="award-primary"
              className="relative border border-[#E5D3B3]/30 p-10 md:p-14 bg-gradient-to-br from-[#0A1320] to-[#050B14] overflow-hidden h-full"
            >
              <div className="absolute top-0 left-0 w-32 h-px bg-[#E5D3B3]" />
              <div className="absolute top-0 left-0 w-px h-32 bg-[#E5D3B3]" />
              <div className="absolute bottom-0 right-0 w-32 h-px bg-[#E5D3B3]" />
              <div className="absolute bottom-0 right-0 w-px h-32 bg-[#E5D3B3]" />

              <div className="flex flex-col h-full">
                <div className="flex items-baseline justify-between mb-12">
                  <span className="overline text-[#E5D3B3]">
                    {AWARDS.primaryAward.venue}
                  </span>
                  <span className="font-serif-display text-[#E5D3B3] text-2xl tabular-nums">
                    {AWARDS.primaryAward.year}
                  </span>
                </div>

                <h3 className="font-serif-display text-white text-4xl md:text-6xl font-light leading-[1.05] mb-6">
                  {AWARDS.primaryAward.title}
                </h3>
                <div className="overline text-white/60 mb-8">
                  {AWARDS.primaryAward.category}
                </div>

                <p className="text-[#D4C9A8] text-base md:text-lg font-light leading-relaxed max-w-xl mt-auto">
                  {AWARDS.primaryAward.description}
                </p>
              </div>
            </div>
          </Reveal>

          {/* Secondary recognition stack */}
          <div className="col-span-12 lg:col-span-5 flex flex-col gap-6">
            {AWARDS.secondary.map((s, i) => (
              <Reveal
                key={s.title}
                delay={0.25 + i * 0.1}
                className="border border-white/10 p-8 md:p-10 hover:border-[#E5D3B3]/40 transition-colors duration-700"
              >
                <div className="flex items-baseline justify-between mb-6">
                  <span className="overline">0{i + 2}</span>
                  <div className="h-px w-12 bg-white/20" />
                </div>
                <h3 className="font-serif-display text-white text-2xl md:text-3xl font-light leading-tight mb-4">
                  {s.title}
                </h3>
                <p className="text-[#D4C9A8] text-sm font-light leading-relaxed">
                  {s.desc}
                </p>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal>
          <p
            data-testid="awards-disclaimer"
            className="mt-16 max-w-3xl text-xs uppercase tracking-[0.18em] text-white/40 leading-loose"
          >
            * {AWARDS.note}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
